<template>
  <div
    class="f-field"
    :class="{'f-field--required' : isRequired}"
  >
    <input
      :id="fieldName"
      :name="fieldName"
      :placeholder="placeholder"
      :required="isRequired"
      class="f-field__input"
      :class="{ 'f-field__input--is-filled': modelValue !== '' }"
      type="number"
      :value="modelValue"
      :min="minValue"
      :max="maxValue"
      @input="$emit('update:modelValue', $event.target.value)"
    >
    <label
      v-if="showLabel"
      :for="fieldName"
      class="f-field__label"
    >
      {{ label ? label : $t(`fields.${fieldName}.label`) }}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      default: null,
      type: String
    },
    fieldName: {
      type: String,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: null
    },
    minValue: {
      type: Number,
      default: null
    },
    maxValue: {
      type: Number,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue']
}
</script>
